const IAnalyticsServiceId = Symbol("IAnalyticsService");
import { AnalyticsEvent } from "../../models/analytics";
import { AnalyticsEventName } from "../../enums/analyticsEventName";

interface IAnalyticsService {

    RecordEvent(eventName: AnalyticsEventName, dataValues?: AnalyticsEvent);
}
export { IAnalyticsServiceId, IAnalyticsService }